export default __webpack_public_path__ + "static/media/v3.dd36e1f8.png";